import { Modal, Paper } from '@mui/material';
import { FC } from 'react';

import { LoginForm } from '../login-form';
import { ForgottenPasswordForm } from '../forgotten-password-form';

import { styles } from './styles';
import { LoginModalProps } from './types';

export const LoginModal: FC<LoginModalProps> = ({
    open,
    closeFn,
    showPasswordReset,
    handleShowPasswordReset,
    currentEmail,
    redirectUrl,
}) => (
    <Modal open={open} css={styles.loginDialogModal} onClose={closeFn}>
        <Paper variant="outlined" css={styles.loginDialogPaper}>
            {!showPasswordReset ? (
                <LoginForm
                    closeFn={closeFn}
                    handleShowPasswordReset={handleShowPasswordReset}
                    currentEmail={currentEmail}
                    redirectUrl={redirectUrl}
                />
            ) : (
                <ForgottenPasswordForm
                    closeFn={closeFn}
                    handleShowPasswordReset={handleShowPasswordReset}
                />
            )}
        </Paper>
    </Modal>
);
